import { RECRUITING_COUNTRY } from '../config/config'

/**
 * Determines if a country is a recruiting country where careers should be displayed
 * @param country - The country code to check (e.g., 'IL', 'US')
 * @returns true if the country is a recruiting country, false otherwise
 */
export function isRecruitingCountry(country?: string): boolean {
  return country?.toUpperCase() === RECRUITING_COUNTRY
}
